var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam_left" },
    [
      _c(
        "div",
        { staticClass: "left_wrap" },
        [
          _vm.paperData !== null
            ? _c(
                "el-collapse",
                {
                  staticStyle: {
                    "overflow-y": "auto",
                    "overflow-x": "hidden",
                    height: "100%"
                  },
                  model: {
                    value: _vm.activeNames,
                    callback: function($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames"
                  }
                },
                [
                  _vm._l(_vm.leftData, function(data, index) {
                    return _c(
                      "el-collapse-item",
                      {
                        key: index,
                        attrs: {
                          title: "" + (data.sectionAlias || data.sectionName),
                          name: index
                        }
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "topic_wrap" },
                          [
                            _vm._l(data.testPaperQuestionsList, function(
                              item,
                              index1
                            ) {
                              return data.orderSort === 0
                                ? _c(
                                    "li",
                                    {
                                      key: index1,
                                      staticClass: "topic_num",
                                      class: [
                                        { active: _vm.num === item.id },
                                        { select: item.selected },
                                        { makeAnswer: item.makeAnswer }
                                      ],
                                      attrs: { title: item.selected },
                                      on: {
                                        click: function($event) {
                                          return _vm.setQuestion(
                                            item,
                                            item.id,
                                            index1,
                                            item.questionId
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "top" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(index1 + 1))
                                        ]),
                                        item.selected && !item.makeAnswer
                                          ? _c("i")
                                          : item.makeAnswer &&
                                            (!item.selected || item.selected)
                                          ? _c("i", [_vm._v("?")])
                                          : _c("i", [_vm._v("*")])
                                      ]),
                                      _vm._v(" "),
                                      _c("p")
                                    ]
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm._l(data.testPaperQuestionsList, function(
                              item,
                              index1
                            ) {
                              return data.orderSort === 1
                                ? _c(
                                    "li",
                                    {
                                      key: index1,
                                      staticClass: "topic_num",
                                      class: [
                                        { active: _vm.num === item.id },
                                        { select: item.selected },
                                        { makeAnswer: item.makeAnswer }
                                      ],
                                      attrs: { title: item.selected },
                                      on: {
                                        click: function($event) {
                                          return _vm.setQuestion(
                                            item,
                                            item.id,
                                            index1,
                                            item.questionId
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "top" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(index1 + 1))
                                        ]),
                                        item.selected && !item.makeAnswer
                                          ? _c("i")
                                          : item.makeAnswer &&
                                            (!item.selected || item.selected)
                                          ? _c("i", [_vm._v("?")])
                                          : _c("i", [_vm._v("*")])
                                      ]),
                                      _vm._v(" "),
                                      _c("p")
                                    ]
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm._l(data.testPaperQuestionsList, function(
                              item,
                              index1
                            ) {
                              return data.orderSort === 2
                                ? _c(
                                    "li",
                                    {
                                      key: index1,
                                      staticClass: "topic_num",
                                      class: [
                                        { active: _vm.num === item.id },
                                        { select: item.selected },
                                        { makeAnswer: item.makeAnswer }
                                      ],
                                      attrs: { title: item.selected },
                                      on: {
                                        click: function($event) {
                                          return _vm.setQuestion(
                                            item,
                                            item.id,
                                            index1,
                                            item.questionId
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "top" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(index1 + 1))
                                        ]),
                                        item.selected && !item.makeAnswer
                                          ? _c("i")
                                          : item.makeAnswer &&
                                            (!item.selected || item.selected)
                                          ? _c("i", [_vm._v("?")])
                                          : _c("i", [_vm._v("*")])
                                      ]),
                                      _vm._v(" "),
                                      _c("p")
                                    ]
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm._l(data.testPaperQuestionsList, function(
                              item,
                              index1
                            ) {
                              return data.orderSort === 3
                                ? _c(
                                    "li",
                                    {
                                      key: index1,
                                      staticClass: "topic_num",
                                      class: [
                                        { active: _vm.num === item.id },
                                        { select: item.selected },
                                        { makeAnswer: item.makeAnswer }
                                      ],
                                      attrs: { title: item.selected },
                                      on: {
                                        click: function($event) {
                                          return _vm.setNoQuestion(
                                            item,
                                            item.id,
                                            index1,
                                            item.questionId
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "top" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(index1 + 1))
                                        ]),
                                        item.selected && !item.makeAnswer
                                          ? _c("i")
                                          : item.makeAnswer &&
                                            (!item.selected || item.selected)
                                          ? _c("i", [_vm._v("?")])
                                          : _c("i", [_vm._v("*")])
                                      ]),
                                      _vm._v(" "),
                                      _c("p")
                                    ]
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "left_footer" }, [
                    _c("p", [_vm._v("说明：")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("1.题目右方的“*”符号代表该小题尚未选择答案。")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("2.题目右方的“?”符号代表该小题做过标记。")
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("3.选择选项的同时自动保存答案。")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "jsq" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../../../static/images/testImgs/jsq.png")
                      },
                      on: { click: _vm.jsqShow }
                    })
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("Calculator", { attrs: { isCalculatorShow: _vm.isCalculatorShow } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7bf76b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7bf76b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testSumulationComponent/examLeft.vue
// module id = null
// module chunks = 